import { render, staticRenderFns } from "./ServersGroupsView.vue?vue&type=template&id=68ae17de&scoped=true"
import script from "./ServersGroupsView.vue?vue&type=script&lang=js"
export * from "./ServersGroupsView.vue?vue&type=script&lang=js"
import style0 from "./ServersGroupsView.vue?vue&type=style&index=0&id=68ae17de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae17de",
  null
  
)

export default component.exports